import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import Spinner from "../../components/LoadingSpinner/loadingSpinner";
import api from "../../api";
import "../../assets/css/styles.css";
const RewardsSponsorModal = ({
  show,
  onClose,
  sponsorshipRewards = [],
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;

    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/rewardsModal/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);
  const currencyMap = {
    EUR: "€",
    USD: "$",
    GBP: "£",
  };
  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return "00:00:00";

    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");

    return `${h}:${m}:${s}`;
  };
  const renderPackages = (reward) =>
    reward?.packages?.map((pkg) => (
      <div key={pkg.id} className="flex gap-1 align-items-center mb-2">
        <span className="mb-0 fs-20 font-600">{pkg.name}</span>
        <span>
          {pkg.items?.map((item) => {
            const duration =
              item.unit === "period" ? formatDuration(item.size) : item.size;

            const label =
              item.unit === "period" ? languageData.call : languageData.message;

            return (
              <span key={item.id}>
                ({duration} {label})
              </span>
            );
          })}
        </span>
        <span class="pack_price">
          {pkg.price} {currencyMap[pkg.currency]}
        </span>
      </div>
    ));
  const formatTime = (seconds) => {
    const sec = Number(seconds);

    if (isNaN(sec)) return "00:00:00";

    const hrs = String(Math.floor(sec / 3600)).padStart(2, "0");
    const mins = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const secs = String(sec % 60).padStart(2, "0");

    return `${hrs}:${mins}:${secs}`;
  };
  const takeLoyality = async (reward) => {
    try {
      setLoading(true);
      const response = await api.post(`/services/take-loyalty-reward`, {
        reward_id: reward.id,
      });
      const responseData = response.data?.data || {};
      const paymentUrl = responseData.payment_url;
      const addedCredits = responseData.added_credits || [];
      if (
        (reward.type === "discount" || reward.type === "package") &&
        paymentUrl
      ) {
        const width = 800;
        const height = 900;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        window.open(
          paymentUrl,
          "PaymentWindow",
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
        );

        return;
      }

     // PROGRAM PAYMENT
      if (addedCredits) {
        const creditsHtml = addedCredits
        .map((credit) => {
          if (
            credit.unit === "period" &&
            credit.communication_type === "call"
          ) {
            return `
        <li class="flex align-items-center justify-content-center gap-1 mb-2">
          <i class="bi bi-telephone-fill"></i>
          ${formatTime(credit.credit)}
          ${languageData.call}
        </li>
      `;
          }

          if (credit.communication_type === "email") {
            return `
        <li class="flex align-items-center justify-content-center gap-1 mb-2">
          <i class="bi bi-envelope-fill"></i>
          ${credit.credit} emails
        </li>
      `;
          }

          if (credit.communication_type === "chat") {
            return `
        <li class="flex align-items-center justify-content-center gap-1 mb-2">
          <i class="bi bi-chat-fill"></i>
          ${credit.credit} messages
        </li>
      `;
          }

          return "";
        })
        .join("");

      await Swal.fire({
        icon: "success",
        title: languageData.alert.success.title,
        html: `
            <p class="fs-16">${languageData.alert.success.description}</p>
            <ul class="font-16 flex flex-column align-items-center justify-content-center">
              ${creditsHtml}
            </ul>
          `,
        confirmButtonText: "OK",
      });
    } else {
      const result = await Swal.fire({
        icon: "success",
        title: languageData.free_reward_success,
        confirmButtonText: languageData.go_payment,
      });
       if (result.isConfirmed) {

            const width = 800;
            const height = 900;
            const left = window.screenX + (window.outerWidth - width) / 2;
            const top = window.screenY + (window.outerHeight - height) / 2;
            window.open(
              paymentUrl,
              "PaymentWindow",
              `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
            );

       }
    }
     

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: languageData.alert.something_went_wrong.title,
        text:
          error?.response?.data?.message ||
          languageData.alert.something_went_wrong.description,
      });
    } finally {
      setLoading(false);
    }
  };




  const takeSponsorship = async (reward) => {
    try {
      setLoading(true);
      const response = await api.post(`/services/take-sponsorship-reward`, {
        reward_id: reward.id,
      });
      const responseData = response.data?.data || {};
      const paymentUrl = responseData.payment_url;
      const loyalty_points = responseData.loyalty_points;
      if (
        (reward.type === "discount" || reward.type === "package") &&
        paymentUrl
      ) {
        const width = 800;
        const height = 900;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        window.open(
          paymentUrl,
          "PaymentWindow",
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
        );

        return;
      }
      // PROGRAM PAYMENT
       if (loyalty_points) {
      await Swal.fire({
        icon: "success",
        title: languageData.alert.success.title,
        html: `
            <p class="fs-16">${languageData.alert.success.subtitle}</p>
            <ul class="font-16 flex flex-column align-items-center justify-content-center">
              ${loyalty_points}
            </ul>
          `,
        confirmButtonText: "OK",
      });
    } else {
      const result = await Swal.fire({
        icon: "success",
        title: languageData.free_reward_success,
        confirmButtonText: languageData.go_payment,
      });
       if (result.isConfirmed) {

            const width = 800;
            const height = 900;
            const left = window.screenX + (window.outerWidth - width) / 2;
            const top = window.screenY + (window.outerHeight - height) / 2;
            window.open(
              paymentUrl,
              "PaymentWindow",
              `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
            );

       }
    }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: languageData.alert.something_went_wrong.title,
        text:
          error?.response?.data?.message ||
          languageData.alert.something_went_wrong.description,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!languageData) {
    return <div></div>;
  }
  if (!languageData) {
    return <div></div>;
  }
  return (
    <Modal show={show} onHide={onClose} centered>
      <div class="modal-top">
       
        <div class="modal-icon-wrap">
          <i class="ti ti-gift"></i>
        </div>
        <div class="modal-arc"></div>
      </div>

      <div className="rewardsModal">
        {/* sponsorship*/}
        {sponsorshipRewards?.length > 0 && (
          <div className="modal-body flex align-items-center flex-column justify-content-center">
            <p className="modal-title mb-2">{languageData.sponsorship.title}</p>

            <div className="modal-divider"></div>

            {sponsorshipRewards.map((reward) => {
              const currencyMap = {
                EUR: "€",
                USD: "$",
                GBP: "£",
              };

              return (
                <div key={reward.id} className="reward-block">
                  {reward.type === "discount" && (
                    <div className="offer-desc flex">
                      <span class="discountLabel">
                        {languageData.discount}{" "}
                        {parseFloat(reward.discounts?.value)}%{" "}
                      </span>
                    </div>
                  )}
                  {reward.packages?.map((pkg) => (
                    <div key={pkg.id} className="offer-row">
                       <div>
                        <div className="offer-name">{pkg.name}</div>

                        <div className="offer-desc">
                          {pkg.items?.map((item) => {
                            const duration =
                              item.unit === "period"
                                ? formatDuration(item.size)
                                : item.size;

                            const label =
                              item.unit === "period"
                                ? languageData.call
                                : languageData.message;

                            return (
                              <span key={item.id}>
                                {duration} {label}{" "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div className="offer-pill">
                        <div className="offer-pill-price">
                          {pkg.price} {currencyMap[pkg.currency]}
                        </div>
                      </div>
                    </div>
                  ))}
                  <div class="total-row">
                    <span class="total-label">{languageData.total}</span>
                    <span class="total-value">
                      {reward.type === "discount"
                        ? reward.discounted_price
                        : reward.price}
                      {currencyMap[reward.currency]}
                    </span>
                  </div>

                  {Number(reward?.available_usage) > 0 && (
                    <button data-interaction="take_sponsorship_reward"
                      className="btn-main mt-2"
                      onClick={() => takeSponsorship(reward)}
                    >
                      <i className="ti ti-arrow-right"></i>

                      {languageData.free_button}
                    </button>
                  )}

                  <div className="modal-divider"></div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </Modal>
  );
};
export default RewardsSponsorModal;
